const initTab = {
	tag: 'home', //tabObjs对象中的key
	label: '首页',
	name: 'home',
	content: '首页',
	param: {}, //页面跳转时需要的参数
	menu_id: null, //该menu_id是用于部分列表页切换的下拉框数据
}
export default {
	state: {
		//所有的路由对象集合
		allPath: {},
		initTab: {
			tag: 'home', //tabObjs对象中的key
			label: '首页',
			name: 'home',
			content: '首页',
			param: {}, //页面跳转时需要的参数
			menu_id: null, //该menu_id是用于部分列表页切换的下拉框数据
		},
		//登录后数据
		loginData: undefined,
		currentTabPage: {
			type: '', //change,add,del
			currentTab: initTab,
		},
		//以对象的形式存放tabs
		tabObjs: {
			home: initTab
		},
		//全局共享当前或上次浏览的表的数据
		currentTable: undefined,
		//当跳转的页路由页面为同一页面，强制刷新
		commonPage: initTab,
		//全局tabs对象
		tabsDom: undefined,
		//当前页面参数
		currentPageParam: undefined,
		biaotouName: '',
		cabinetName: '',
		zxtabledata: []
	},
	//	--------------------------分割线--------------------------------------------------
	mutations: {
		//删除顶部tab
		muDelTab(state, name) {
			for (let idx in state.topTabs) {
				if (state.topTabs[idx].name == name) {
					state.currentTab = state.topTabs[idx - 1]
					state.topTabs.splice(idx, 1)
				}
			}
		}
	},
	//	--------------------------分割线-------------------------------------------------
	actions: {
		//添加顶部标签，一般是侧边点击事件
		addTopTab({
			state,
			commit
		}, obj) {
			//新增需要更新tabs
			state.tabObjs[obj.tag] = obj
			state.currentTabPage = {
				type: 'addTab',
				currentTab: obj,
			}
		},
		//切换顶部标签
		changeTopTab({
			state,
			commit
		}, obj) {
			//切换不需要更新tabs,但是需要更新传递的参数
			state.tabObjs[obj.tag].param = obj.param
			state.currentTabPage = {
				type: 'changeTab',
				currentTab: obj,
			}
		},
	},
	getters: {},
}



// WEBPACK FOOTER //
// ./src/store/common.js